/**
 * The fields of Advanced (BI)'s band, found by their exact label (as the Virtual Tour finds them), so the "Filled for"
 * block can mark, light and open them (CU-869fmk5ge, UX Obs. 4-5) without touching the shared filters.
 */
const MARK = 'data-bi-goal'
const FLASH = 'data-bi-flash'

export function findBandField(label) {
	const want = String(label).toLowerCase()
	const el = [...document.querySelectorAll('label')].find(l => l.textContent.trim().toLowerCase() === want)
	return el?.closest('.MuiGrid-item') || el?.closest('.MuiFormControl-root') || null
}

/** `{ <field label>: 'filled' | 'choose' }` on the fields; any other mark goes */
export function markFields(marks) {
	document.querySelectorAll(`[${MARK}]`).forEach(el => el.removeAttribute(MARK))
	for (const [label, mark] of Object.entries(marks || {})) findBandField(label)?.setAttribute(MARK, mark)
}

export const clearMarks = () => markFields({})

export function flashField(label, on) {
	const el = findBandField(label)
	if (!el) return
	if (on) el.setAttribute(FLASH, '1')
	else el.removeAttribute(FLASH)
}

/** "Choose": opens the field (its date picker or its list) */
export function openField(label) {
	const el = findBandField(label)
	if (!el) return
	el.scrollIntoView?.({ block: 'center' })
	const picker = el.querySelector('.rs-picker-toggle')
	if (picker) { picker.click(); return }
	const input = el.querySelector('input')
	input?.focus()
	const opener = el.querySelector('.MuiAutocomplete-popupIndicator, .MuiSelect-select')
	if (opener) opener.dispatchEvent(new window.MouseEvent('mousedown', { bubbles: true }))
	opener?.click?.()
}
